/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type { CreateImagingDiagnosisDto, PatientCategory, SecondaryDiagnosisDto, SocialAnamnesisDto, SymptomDto } from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const updateSocialAnamnesis = (
  id: string,
  socialAnamnesisDto: BodyType<SocialAnamnesisDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<SocialAnamnesisDto>(
    {
      url: `/api/anamneses/${id}/social`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: socialAnamnesisDto,
    },
    options,
  );
};

export const getUpdateSocialAnamnesisMutationOptions = <
  TData = Awaited<ReturnType<typeof updateSocialAnamnesis>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<SocialAnamnesisDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateSocialAnamnesis'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSocialAnamnesis>>,
    { id: string; data: BodyType<SocialAnamnesisDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSocialAnamnesis(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<SocialAnamnesisDto> },
    TContext
  >;
};

export type UpdateSocialAnamnesisMutationResult = NonNullable<Awaited<ReturnType<typeof updateSocialAnamnesis>>>;
export type UpdateSocialAnamnesisMutationBody = BodyType<SocialAnamnesisDto>;
export type UpdateSocialAnamnesisMutationError = ErrorType<unknown>;

export const useUpdateSocialAnamnesis = <
  TData = Awaited<ReturnType<typeof updateSocialAnamnesis>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<SocialAnamnesisDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<SocialAnamnesisDto> }, TContext> => {
  const mutationOptions = getUpdateSocialAnamnesisMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createAnamnesisSymptom = (
  id: string,
  symptomDto: BodyType<SymptomDto[]>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/anamneses/${id}/symptoms`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: symptomDto,
      signal,
    },
    options,
  );
};

export const getCreateAnamnesisSymptomMutationOptions = <
  TData = Awaited<ReturnType<typeof createAnamnesisSymptom>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<SymptomDto[]> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createAnamnesisSymptom'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAnamnesisSymptom>>,
    { id: string; data: BodyType<SymptomDto[]> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createAnamnesisSymptom(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<SymptomDto[]> },
    TContext
  >;
};

export type CreateAnamnesisSymptomMutationResult = NonNullable<Awaited<ReturnType<typeof createAnamnesisSymptom>>>;
export type CreateAnamnesisSymptomMutationBody = BodyType<SymptomDto[]>;
export type CreateAnamnesisSymptomMutationError = ErrorType<unknown>;

export const useCreateAnamnesisSymptom = <
  TData = Awaited<ReturnType<typeof createAnamnesisSymptom>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<SymptomDto[]> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<SymptomDto[]> }, TContext> => {
  const mutationOptions = getCreateAnamnesisSymptomMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createAnamnesisSecondaryDiagnosis = (
  id: string,
  secondaryDiagnosisDto: BodyType<SecondaryDiagnosisDto[]>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/anamneses/${id}/secondary-diagnoses`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: secondaryDiagnosisDto,
      signal,
    },
    options,
  );
};

export const getCreateAnamnesisSecondaryDiagnosisMutationOptions = <
  TData = Awaited<ReturnType<typeof createAnamnesisSecondaryDiagnosis>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<SecondaryDiagnosisDto[]> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createAnamnesisSecondaryDiagnosis'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAnamnesisSecondaryDiagnosis>>,
    { id: string; data: BodyType<SecondaryDiagnosisDto[]> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createAnamnesisSecondaryDiagnosis(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<SecondaryDiagnosisDto[]> },
    TContext
  >;
};

export type CreateAnamnesisSecondaryDiagnosisMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAnamnesisSecondaryDiagnosis>>
>;
export type CreateAnamnesisSecondaryDiagnosisMutationBody = BodyType<SecondaryDiagnosisDto[]>;
export type CreateAnamnesisSecondaryDiagnosisMutationError = ErrorType<unknown>;

export const useCreateAnamnesisSecondaryDiagnosis = <
  TData = Awaited<ReturnType<typeof createAnamnesisSecondaryDiagnosis>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<SecondaryDiagnosisDto[]> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<SecondaryDiagnosisDto[]> }, TContext> => {
  const mutationOptions = getCreateAnamnesisSecondaryDiagnosisMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createAnamnesisImagingDiagnosis = (
  id: string,
  createImagingDiagnosisDto: BodyType<CreateImagingDiagnosisDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/anamneses/${id}/imaging-diagnoses`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createImagingDiagnosisDto,
      signal,
    },
    options,
  );
};

export const getCreateAnamnesisImagingDiagnosisMutationOptions = <
  TData = Awaited<ReturnType<typeof createAnamnesisImagingDiagnosis>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateImagingDiagnosisDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createAnamnesisImagingDiagnosis'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAnamnesisImagingDiagnosis>>,
    { id: string; data: BodyType<CreateImagingDiagnosisDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createAnamnesisImagingDiagnosis(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<CreateImagingDiagnosisDto> },
    TContext
  >;
};

export type CreateAnamnesisImagingDiagnosisMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAnamnesisImagingDiagnosis>>
>;
export type CreateAnamnesisImagingDiagnosisMutationBody = BodyType<CreateImagingDiagnosisDto>;
export type CreateAnamnesisImagingDiagnosisMutationError = ErrorType<unknown>;

export const useCreateAnamnesisImagingDiagnosis = <
  TData = Awaited<ReturnType<typeof createAnamnesisImagingDiagnosis>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateImagingDiagnosisDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<CreateImagingDiagnosisDto> }, TContext> => {
  const mutationOptions = getCreateAnamnesisImagingDiagnosisMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updatePatientCategory = (
  id: string,
  patientCategoryDto: BodyType<{ patientCategory: PatientCategory }>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/anamneses/${id}/patient-category`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: patientCategoryDto,
    },
    options,
  );
};

export const getUpdatePatientCategoryMutationOptions = <
  TData = Awaited<ReturnType<typeof updatePatientCategory>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<{ patientCategory: PatientCategory }> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updatePatientCategory'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePatientCategory>>,
    { id: string; data: BodyType<{ patientCategory: PatientCategory }> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePatientCategory(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<{ patientCategory: PatientCategory }> },
    TContext
  >;
};

export type UpdatePatientCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updatePatientCategory>>>;
export type UpdatePatientCategoryMutationBody = BodyType<{ patientCategory: PatientCategory }>;
export type UpdatePatientCategoryMutationError = ErrorType<unknown>;

export const useUpdatePatientCategory = <
  TData = Awaited<ReturnType<typeof updatePatientCategory>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<{ patientCategory: PatientCategory }> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<{ patientCategory: PatientCategory }> }, TContext> => {
  const mutationOptions = getUpdatePatientCategoryMutationOptions(options);

  return useMutation(mutationOptions);
};
